import { Box } from '@chakra-ui/react';
import { advisorsBreadcrumbsWithTrail, useAdvisorsToolbar } from '@src/components/sco/Advisors/hooks/useAdvisorsToolbar';
import { useAdvisorsPaths } from '@src/components/sco/Advisors/paths';
import { UserProfile } from '@src/components/sco/Members/UserProfile';
import { useActiveContentContext } from '@src/contexts/ActiveContentContext';
import { useRouter } from 'next/router';
import { useMemo } from 'react';

/**
 * Marketplace advisor profile inside Advisors chrome (left nav + Advisors breadcrumbs).
 * Reuses the members UserProfile body; does not use Members/Founders breadcrumb trail.
 */
export const AdvisorProfileSection = () => {
  const paths = useAdvisorsPaths();
  const router = useRouter();
  const activeContent = useActiveContentContext();
  const memberSlug = typeof router.query.memberSlug === 'string' ? router.query.memberSlug : Array.isArray(router.query.memberSlug) ? router.query.memberSlug[0] : '';
  const profileTitle = (activeContent.item as {
    fullName?: string;
    displayName?: string;
  } | null | undefined)?.fullName || (activeContent.item as {
    fullName?: string;
    displayName?: string;
  } | null | undefined)?.displayName || 'Profile';
  const breadcrumbs = useMemo(() => advisorsBreadcrumbsWithTrail({
    title: 'Find advisors',
    href: paths.directory
  }, {
    title: profileTitle,
    href: memberSlug ? `${paths.profile}/${memberSlug}` : paths.profile
  }), [memberSlug, profileTitle]);
  useAdvisorsToolbar({
    breadcrumbs
  });
  if (!memberSlug) {
    return null;
  }

  // AdvisorsMainPanel clips overflow; members profile expects a scrolling parent.
  return <Box height={'full'} overflowY={'auto'} width={'full'}>
      <UserProfile manageBreadcrumbs={false} userSlug={memberSlug} />
    </Box>;
};